import {useTranslation} from "react-i18next"

import {PaymentOption} from "./PaymentOption"

import {usePaymentArrangementInitiateInFullSetup} from "@indebted/payment-arrangement/usePaymentArrangementInitiateSetup"

function PaymentArrangementInFullOptionLink() {
	const initiateSetupMutation = usePaymentArrangementInitiateInFullSetup()
	const {t} = useTranslation()

	return (
		<PaymentOption
			Type="PaymentArrangementInFull"
			onClick={() => !initiateSetupMutation.isPending && initiateSetupMutation.mutate()}
			Title={t("customer_get.outstanding_balance.payment.make_payment_in_full")}
			Description={t("customer_get.outstanding_balance.payment.clear_amount_today")}
		/>
	)
}

export {PaymentArrangementInFullOptionLink}
